import type { GetServerSideProps, GetServerSidePropsResult } from 'next';

import type { Props } from 'components/pagesComponents/auth/LoginPage/types';
import RegistrationPage from 'components/pagesComponents/auth/RegistrationPage';

import { wrapper } from 'redux-store';
import getProfileThunk from 'redux-store/thunks/profile/getProfileThunk';
import getSocialProvidersThunk from 'redux-store/thunks/profile/getSocialProvidersThunk';
import { setRegion } from 'redux-store/slices/ui';

import { startSpanAndSetTransaction } from 'utils/APMService';
import { isRequestAuthenticated } from 'utils/auth/isRequestAuthenticated';
import getTranslate from 'utils/getTranslate';
import redirectAuthorizedUser from 'utils/redirectAuthorizedUser';

export default RegistrationPage;

export const getServerSideProps: GetServerSideProps =
  wrapper.getServerSideProps(
    store =>
      async (context): Promise<GetServerSidePropsResult<Props>> => {
        const endSpan = startSpanAndSetTransaction(context.resolvedUrl);
        const isAuthenticated = isRequestAuthenticated(context.req);

        const region = (context.req.headers['cf-ipcountry'] as string) || '';
        if (region) {
          await store.dispatch(setRegion(region));
        }

        if (isAuthenticated) {
          await store.dispatch(getProfileThunk(context));
        }
        await store.dispatch(getSocialProvidersThunk());

        endSpan();

        return redirectAuthorizedUser<Props>(store.getState(), {
          ...(await getTranslate(context)),
        });
      },
  );
